var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"基本参数配置","name":"first"}}),_c('el-tab-pane',{attrs:{"label":"其他配置","name":"second"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }